// extracted by mini-css-extract-plugin
module.exports = {"main":"RegistrationReminder_main__P8tQ_"};